class Scroll {

  id: string;
  constructor(id: string) {
    this.id = id;
  }

  scroll() {
    let element: any = document.getElementById(this.id);
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return element;
  }

}

export default Scroll;
